import React from "react";

/** "Section weights: 95 / 100" with a bar; red until it reaches exactly 100. */
const WeightMeter = ({ label, total }) => {
  const ok = Math.abs(total - 100) < 0.001;
  return (
    <div className={`weight-meter ${ok ? "is-ok" : "is-off"}`} role="status">
      <div className="d-flex justify-content-between fs-080 fw-semibold">
        <span>{label}</span>
        <span className="tabular-nums">
          {total} / 100{" "}
          {ok ? (
            <i className="bi bi-check-circle-fill"></i>
          ) : (
            <i className="bi bi-exclamation-circle-fill"></i>
          )}
        </span>
      </div>
      <div className="weight-meter-track">
        <div
          className="weight-meter-fill"
          style={{ "--fill": `${Math.min(total, 100)}%` }}
        ></div>
      </div>
    </div>
  );
};

export default WeightMeter;
